"use client";

import classNames from "classnames";
import styles from "./styles/SchoolFeedDisplay.module.scss";
import ClickableLink from "../utilities/ClickableLink";
import { Text } from "@radix-ui/themes";

export function SchoolFeedMobileWidgetLink(props: {
  active: boolean;
  src: string;
  text: string;
  href: string | object;
  className?: string;
  color: string;
}) {
  const linkClassName = classNames({
    [styles.link]: true,
    [styles.linkActive]: props.active,
    [props.className || ""]: !!props.className,
  });
  return (
    <ClickableLink
      style={{
        background: props.active ? `var(--${props.color}-3)` : "white",
        border: props.active
          ? `2px solid var(--${props.color}-6)`
          : "2px solid white",
      }}
      href={props.href}
      className={linkClassName}
    >
      <img aria-hidden={true} src={props.src} />
      <Text weight={"medium"}>{props.text}</Text>
    </ClickableLink>
  );
}
